var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('form-component',{attrs:{"page":_vm.aboutUsHomepage},on:{"onSubmit":_vm.onSubmit,"fetchByLocale":_vm.fetchAboutUsHomepage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }